module.exports = __webpack_public_path__ + "static/media/brent_comber.61f67bcb.jpg";